module.exports = {
  SearchStore: {}
};